import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { MarketNamingTemplateFieldsFragmentDoc } from '../../../fragments/marketNamingTemplateFields.generated';
import { KeywordTagFieldsFragmentDoc } from '../../../fragments/keywordTagFields.generated';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegulationsQueryQueryVariables = Types.Exact<{
  queryArgs: Types.QueryArgsInput;
}>;


export type GetRegulationsQueryQuery = { __typename?: 'Query', regulationsQuery: { __typename?: 'RegulationsInfinityResults', regulationIds: Array<string>, regulationFilterOptions: { __typename?: 'RegulationFilterOptions', regulationOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, marketOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, mainKeywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, pcmsOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, icsCodeOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }> }, regulationsBatch: Array<{ __typename?: 'Regulation', id: string, hidden: boolean, regulationNumber: string, name: string, summary: string, createdAt?: any | null, modifiedAt?: any | null, contactPersons: Array<{ __typename?: 'User', id: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string, regulationNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }>, regulatoryDocumentNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }> }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }>, createdBy: { __typename?: 'User', id: string, name: string, mail?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', id: string, name: string, mail?: string | null, userPrincipalName?: string | null }, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, icsCodes: Array<{ __typename?: 'IcsCode', id: string, name: string }> }> } };

export type GetRegulationsNextQueryVariables = Types.Exact<{
  nextArgs: Types.NextArgsInput;
}>;


export type GetRegulationsNextQuery = { __typename?: 'Query', regulationsNext: Array<{ __typename?: 'Regulation', id: string, hidden: boolean, regulationNumber: string, name: string, summary: string, createdAt?: any | null, modifiedAt?: any | null, contactPersons: Array<{ __typename?: 'User', id: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string, regulationNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }>, regulatoryDocumentNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }> }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }>, createdBy: { __typename?: 'User', id: string, name: string, mail?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', id: string, name: string, mail?: string | null, userPrincipalName?: string | null }, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, icsCodes: Array<{ __typename?: 'IcsCode', id: string, name: string }> }> };

export type GetRegulationsSortOrderQueryVariables = Types.Exact<{
  sortArgs: Types.SortArgsInput;
}>;


export type GetRegulationsSortOrderQuery = { __typename?: 'Query', regulationsSortOrder: Array<string> };


export const GetRegulationsQueryDocument = gql`
    query GetRegulationsQuery($queryArgs: QueryArgsInput!) {
  regulationsQuery(queryArgs: $queryArgs) {
    regulationIds
    regulationFilterOptions {
      regulationOptions {
        name
        optionKey
      }
      marketOptions {
        name
        optionKey
      }
      mainKeywordOptions {
        name
        optionKey
      }
      keywordOptions {
        name
        optionKey
      }
      pcmsOptions {
        name
        optionKey
      }
      icsCodeOptions {
        name
        optionKey
      }
    }
    regulationsBatch {
      id
      hidden
      regulationNumber
      name
      summary
      contactPersons {
        id
      }
      markets {
        id
        name
        ...MarketNamingTemplateFields
      }
      mainKeywords {
        id
        name
      }
      keywords {
        ...KeywordTagFields
      }
      standardPlusPcmsClusters {
        id
        name
      }
      createdAt
      modifiedAt
      createdBy {
        id
        name
        mail
        userPrincipalName
      }
      modifiedBy {
        id
        name
        mail
        userPrincipalName
      }
      attachments {
        ...AttachmentFields
      }
      icsCodes {
        id
        name
      }
    }
  }
}
    ${MarketNamingTemplateFieldsFragmentDoc}
${KeywordTagFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}`;

/**
 * __useGetRegulationsQueryQuery__
 *
 * To run a query within a React component, call `useGetRegulationsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationsQueryQuery({
 *   variables: {
 *      queryArgs: // value for 'queryArgs'
 *   },
 * });
 */
export function useGetRegulationsQueryQuery(baseOptions: Apollo.QueryHookOptions<GetRegulationsQueryQuery, GetRegulationsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationsQueryQuery, GetRegulationsQueryQueryVariables>(GetRegulationsQueryDocument, options);
      }
export function useGetRegulationsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationsQueryQuery, GetRegulationsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationsQueryQuery, GetRegulationsQueryQueryVariables>(GetRegulationsQueryDocument, options);
        }
export type GetRegulationsQueryQueryHookResult = ReturnType<typeof useGetRegulationsQueryQuery>;
export type GetRegulationsQueryLazyQueryHookResult = ReturnType<typeof useGetRegulationsQueryLazyQuery>;
export type GetRegulationsQueryQueryResult = Apollo.QueryResult<GetRegulationsQueryQuery, GetRegulationsQueryQueryVariables>;
export const GetRegulationsNextDocument = gql`
    query GetRegulationsNext($nextArgs: NextArgsInput!) {
  regulationsNext(nextArgs: $nextArgs) {
    id
    hidden
    regulationNumber
    name
    summary
    contactPersons {
      id
    }
    markets {
      id
      name
      ...MarketNamingTemplateFields
    }
    mainKeywords {
      id
      name
    }
    keywords {
      ...KeywordTagFields
    }
    standardPlusPcmsClusters {
      id
      name
    }
    createdAt
    modifiedAt
    createdBy {
      id
      name
      mail
      userPrincipalName
    }
    modifiedBy {
      id
      name
      mail
      userPrincipalName
    }
    attachments {
      ...AttachmentFields
    }
    icsCodes {
      id
      name
    }
  }
}
    ${MarketNamingTemplateFieldsFragmentDoc}
${KeywordTagFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}`;

/**
 * __useGetRegulationsNextQuery__
 *
 * To run a query within a React component, call `useGetRegulationsNextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationsNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationsNextQuery({
 *   variables: {
 *      nextArgs: // value for 'nextArgs'
 *   },
 * });
 */
export function useGetRegulationsNextQuery(baseOptions: Apollo.QueryHookOptions<GetRegulationsNextQuery, GetRegulationsNextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationsNextQuery, GetRegulationsNextQueryVariables>(GetRegulationsNextDocument, options);
      }
export function useGetRegulationsNextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationsNextQuery, GetRegulationsNextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationsNextQuery, GetRegulationsNextQueryVariables>(GetRegulationsNextDocument, options);
        }
export type GetRegulationsNextQueryHookResult = ReturnType<typeof useGetRegulationsNextQuery>;
export type GetRegulationsNextLazyQueryHookResult = ReturnType<typeof useGetRegulationsNextLazyQuery>;
export type GetRegulationsNextQueryResult = Apollo.QueryResult<GetRegulationsNextQuery, GetRegulationsNextQueryVariables>;
export const GetRegulationsSortOrderDocument = gql`
    query GetRegulationsSortOrder($sortArgs: SortArgsInput!) {
  regulationsSortOrder(sortArgs: $sortArgs)
}
    `;

/**
 * __useGetRegulationsSortOrderQuery__
 *
 * To run a query within a React component, call `useGetRegulationsSortOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationsSortOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationsSortOrderQuery({
 *   variables: {
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useGetRegulationsSortOrderQuery(baseOptions: Apollo.QueryHookOptions<GetRegulationsSortOrderQuery, GetRegulationsSortOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationsSortOrderQuery, GetRegulationsSortOrderQueryVariables>(GetRegulationsSortOrderDocument, options);
      }
export function useGetRegulationsSortOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationsSortOrderQuery, GetRegulationsSortOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationsSortOrderQuery, GetRegulationsSortOrderQueryVariables>(GetRegulationsSortOrderDocument, options);
        }
export type GetRegulationsSortOrderQueryHookResult = ReturnType<typeof useGetRegulationsSortOrderQuery>;
export type GetRegulationsSortOrderLazyQueryHookResult = ReturnType<typeof useGetRegulationsSortOrderLazyQuery>;
export type GetRegulationsSortOrderQueryResult = Apollo.QueryResult<GetRegulationsSortOrderQuery, GetRegulationsSortOrderQueryVariables>;